
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="省市">
              <a-cascader :options="areaOptions" allowClear placeholder="请选择" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.registstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">
                <a-select
                        showSearch
                        optionFilterProp="title"
                        v-model="queryParam.type"
                        placeholder="类型"
                        allowClear
                >
                  <a-select-option :value="1">幼儿园</a-select-option>
                  <a-select-option :value="2">小学</a-select-option>
                  <a-select-option :value="3">中学</a-select-option>
                  <a-select-option :value="4">大学</a-select-option>
                  <a-select-option :value="6">俱乐部</a-select-option>
                  <a-select-option :value="5">其他</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="联系电话">
              <a-input v-model="queryParam.phone" placeholder="联系电话"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="申报时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="申报进度">
              <a-select v-model="queryParam.kaoji_jindu" placeholder="请选择"
                        allowClear >
                <a-select-option :key="-1" value="-1">无</a-select-option>
                <!--<a-select-option value="1">等待审核</a-select-option>-->
                <a-select-option :key="2" value="2">告知省级并征求意见+申报单位积极准备中</a-select-option>
                <a-select-option :key="4" value="4">条件已具备，等待验收</a-select-option>
                <a-select-option :key="6" value="6">验收并授牌</a-select-option>
                <a-select-option :key="7" value="7">同意考试</a-select-option>
              </a-select>
            </a-form-item>
          </a-col></template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button @click="download" style="margin-left: 8px" >
        单位信息表下载 <a-icon type="download" />
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url" v-if="false" />
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            负责人:{{record.nickname}} <span style="color: #999">手机:{{record.phone}}</span>
          </div>
      </span>
      <span slot="code" slot-scope="text,record">
            <!--{{record.kaojiregist_code?record.kaojiregist_code:'(无)'}}-->
            <!--<br/>-->
            申请时间 {{record.create_time|timeFormat}}
      </span>
      <span slot="jindu" slot-scope="text,record">
        <a-tag v-if="record.registstatus==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.registstatus==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.registstatus==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleUserEdit(record)">人员管理</a>
          <a-divider type="vertical"  />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"  v-show="record.registstatus==3" />
          <a-popconfirm  v-show="record.registstatus==3" title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          </a-popconfirm>

        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="所属省市"
                      hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.namekeys" changeOnSelect
                />
              </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="类型"
                        hasFeedback
                >

                  <a-select v-model="formData.type" placeholder="请选择"
                             >
                    <a-select-option :value="1">幼儿园</a-select-option>
                    <a-select-option :value="2">小学</a-select-option>
                    <a-select-option :value="3">中学</a-select-option>
                    <a-select-option :value="4">大学</a-select-option>
                    <a-select-option :value="6">俱乐部</a-select-option>
                    <a-select-option :value="5">其他</a-select-option>
                  </a-select>
                </a-form-item>
                </a-col>
              </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位名称"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'name',
          {rules: [ ]}
        ]"
                     placeholder="请输入单位名称"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位地址"
                  hasFeedback
          >
            <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect
            />
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="详细地址"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'address',
          {rules: [ ]}
        ]"
                      placeholder="请输入详细地址"/>
          </a-form-item>
            </a-col>
            </a-row>


          <a-divider>联系人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'nickname',
          {rules: [ ]}
        ]"
                      placeholder="请输入姓名"/>
          </a-form-item>

            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证号"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'certificatenumber',
          {rules: [ ]}
        ]"
                      placeholder="请输入负责人身份证号"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
          <a-col :md="12" :sm="24">
            <a-form-item
                    label="身份证"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
              <pic-uploader
                      :file-list="formData.certificatepic"
              />
            </a-form-item>
          </a-col>

            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="邮箱"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'email',
          {rules: [ ]}
        ]"
                      placeholder="请输入邮箱"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'phone',
          {rules: [ ]}
        ]"
                      placeholder="请输入手机"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="QQ"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'qq',
          {rules: [ ]}
        ]"
                      placeholder="请输入QQ"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="微信"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'weixin',
          {rules: [ ]}
        ]"
                      placeholder="请输入微信"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-divider>审核信息</a-divider>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="备案审核"
                  hasFeedback
          >
            <a-radio-group v-model="formData.registstatus" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">待审核</a-radio-button>
              <a-radio-button :value="2">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="拒绝审核理由"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'registstatusdes',
          {rules: []}
        ]"
                        placeholder="请拒绝审核理由"/>
          </a-form-item>
</a-col>
            </a-row>



        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
        title="人员管理"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userVisible"
        @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
              :columns="userColumns"
              :dataSource="danweiUserList"
              :pagination="userPagination"
              rowKey="id"
              :scroll="{ y: 300 }"
              bordered
              @change="handleUserTableChange"
          >
            <span slot="name" slot-scope="name,record">
              <img :src="record.face" style="width: 40px; vertical-align: middle;" />
              {{record.name}}
            </span>
            <template slot="action" slot-scope="text,record,index">
              <a-popconfirm title="确定重置为123456" @confirm="resetPassword(record)"  okText="确定" cancelText="取消">
                <a href="javascript:;">重置密码</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a-popconfirm
                  title="确定删除此人员吗"
                  @confirm="deleteUser(record,index)"
                  okText="确定"
                  cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <user-picker
                  style="width: 200px; margin-right: 10px;"
                  :formData="userFormData"
                  field="user_id"
              />
<!--              <a-select-->
<!--                  style="width: 200px; margin-right: 10px;"-->
<!--                  v-model="userFormData.type"-->
<!--                  placeholder="角色类型"-->
<!--              >-->
<!--                <a-select-option value="管理员">管理员</a-select-option>-->
<!--                <a-select-option value="店员">店员</a-select-option>-->
<!--              </a-select>-->
              <a-button icon="plus" @click="addUser">新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>



  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import UserPicker from '@/components/UserPicker/'
  import setting from '@/config/setting'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  import qs from 'qs'
  moment.locale('zh-cn');

  import { getDanweiList ,getDanweiDetail,editDanwei,danweiDelete,deleteDanweiUser, addDanweiUser,getDanweiUserList } from '@/api/sai'
  import {setPassword} from "@/api/user";
  export default {
    name: 'DanweiList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      UserPicker,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        userVisible: false,
        formData:{
          id:0,
          danwei:'',
          namekeys:[],
          areas:[],
          certificatepic:[],
        },
        buyGoodsOptions:[
          {
            "label":"1 标准肋木",
            "value":1
          },
          {
            "label":"2 标准把杆（固定/移动）",
            "value":2
          },
          {
            "label":"3 斜坡啦啦操垫（翻滚）",
            "value":4
          },
          {
            "label":"4 啦啦操训练垫",
            "value":8
          },
          {
            "label":"5 柔韧测试器（髋部）",
            "value":16
          },
          {
            "label":"6 积木式跳箱",
            "value":32
          },
          {
            "label":"7 柔韧测试器（肩部）",
            "value":64
          },
          {
            "label":"8 啦啦操翻腾训练辅助器（组合）A",
            "value":128
          },
          {
            "label":"9 啦啦操翻腾训练辅助器（组合）B",
            "value":256
          },
          {
            "label":"10 七彩星级专用训练考试地胶",
            "value":512
          },
          {
            "label":"11 啦啦操方形蹦床",
            "value":1024
          },
          {
            "label":"12啦啦操专用平衡器",
            "value":2048
          }
        ],
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '申请时间',
            dataIndex: 'code',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: '状态',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getDanweiList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },

        userPagination:{
        },
        danweiUserList: [],
        //人员管理表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '用户名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' }
          },
          // {
          //   title: '角色',
          //   width: '100px',
          //   dataIndex: 'role_type'
          // },
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' }
          }
        ],

        userFormData: {
          user_id: undefined,
          type: undefined,
          danwei_id: 0
        },
        userQuery:{
          status:0,
          page:1,
          keywords:undefined
        },
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getDanweiDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.namekey){
              res.data.namekeys = [res.data.namekey.substring(0,2)+'0000',res.data.namekey.substring(0,4)+'00',res.data.namekey];
            }else{
              res.data.namekeys = [];
            }
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editDanwei({
              id:self.formData.id,
              namekey:self.formData.namekeys[self.formData.namekeys.length-1],
              type:self.formData.type,
              name:values.name,
              area:self.formData.areas[self.formData.areas.length-1],
              address:values.address,
              nickname:values.nickname,
              certificatenumber:values.certificatenumber,
              certificatepic:self.formData.certificatepic,
              email:values.email,
              phone:values.phone,
              qq:values.qq,
              weixin:values.weixin,
              registstatus:self.formData.registstatus,
              registstatusdes:values.registstatusdes,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

        // 删
        applyDelete(record) {
            let self = this
            danweiDelete({ id: record.id }).then(res => {
                self.$message.success('删除成功')
                self.$refs.table.refresh()
            }).catch(err =>{
                self.$message.error(err.data.msg)
            })
        },

      download(){  
          window.open(setting.apiBaseURL+'/adminapi/sai/danweiListDownload?'+qs.stringify(this.queryParam)); 
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

      getDanweiUserList() {
        let self = this
        getDanweiUserList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.danweiUserList = res.data.list
        })
      },
      addUser() {
        let self = this
        if (!self.userFormData.user_id) {
          self.$message.error('请选择人员')
          return
        }
        // if (!self.userFormData.type) {
        //   self.$message.error('请选择类型')
        //   return
        // }
        addDanweiUser(self.userFormData)
            .then(res => {
              self.userFormData.user_id = undefined
              self.userFormData.type = undefined
              self.$message.success('新增成功')
              self.getDanweiUserList()
            })
            .catch(err => {
              self.$message.error(err.data.msg)
            })
      },
      deleteUser(record, index) {
        let self = this
        deleteDanweiUser({
          user_id: record.user_id,
          danwei_id: record.danwei_id
        })
            .then(res => {
              self.$message.success('删除成功')
              self.danweiUserList.splice(index, 1)
            })
            .catch(err => {
              self.$message.error(err.data.msg)
            })
      },

      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        // if(filters.user_status){
        //   that.userQuery.status = filters.user_status[0];
        // }else{
        //   that.userQuery.status = 0;
        // }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.userQuery.page = pagination.current;
        that.danweiUserList();
      },

      handleUserEdit(record){
        let self = this
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.userFormData.danwei_id = self.userQuery.danwei_id = record.id
        self.getDanweiUserList()
        self.userVisible = true
        // console.log(this.mdl)
      },
      resetPassword(record) {
        let self = this
        setPassword({ id: record.id ,password:123456}).then(res => {
          self.$message.success('重置成功')
        })
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
